import { lazy, Suspense, useEffect, useState, type ComponentType } from "react";
import type { Deal } from "../types";
import { ErrorBoundary } from "react-error-boundary";

type Props = {
  project: Deal;
  active: boolean;
  permitted: boolean;
  onDirtyChange: (dirty: boolean) => void;
};

/** Keep an opened draft mounted, but never initialize costing for an unopened or unauthorized tab. */
export function createDeferredProjectQuote(
  load: () => Promise<{
    default: ComponentType<Pick<Props, "project" | "onDirtyChange">>;
  }>,
) {
  const Quote = lazy(load);
  return function DeferredQuote({
    project,
    active,
    permitted,
    onDirtyChange,
  }: Props) {
    const id = String(project.id);
    const [opened, setOpened] = useState<string | null>(null);
    useEffect(() => {
      if (permitted && active) setOpened(id);
    }, [id, active, permitted]);
    if (!permitted || (!active && opened !== id)) return null;
    return (
      <ErrorBoundary
        resetKeys={[id]}
        fallback={
          <p role="alert">
            Не удалось открыть КП. Проверьте соединение и обновите страницу,
            чтобы повторить загрузку.
          </p>
        }
      >
        <Suspense fallback={<p role="status">Загрузка конструктора КП…</p>}>
          <Quote project={project} onDirtyChange={onDirtyChange} />
        </Suspense>
      </ErrorBoundary>
    );
  };
}
